import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image.jpg')}
					title={"Establishing a Voice For Your Brand"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 12 Feb 2020  //  Posted in <strong>Branding</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									How to Establish (and Maintain!) a Consistent Brand Voice
								</div>
								
								<p>Establishing a consistent voice for your brand is essential for building trust between your company and your customers. The key to cementing this trust is creating an authentic voice to present to your consumers. </p>
								
								<p>Here at Moshi Moshi Marketing, we’ve created five easy-to-implement steps to get you on your way to finding your own brands’ voice - giving you a brand personality and essentially, generating a resonating, relatable message to your ideal consumer every time. </p>

								<ul>
<li>Establishing Your Brand (Your <b>YOU</b>)</li>
<li>Defining Your Audience (Your <b>WHO</b>)</li>
<li>Your Purpose for Communicating (Your <b>WHY</b>)</li>
<li>Team Transparency (Your <b>PEOPLE</b>)</li>
<li>Start Connecting (Your <b>AUDIENCE</b>)</li>
</ul>
<br></br>
<hr></hr>
<h2>Step 1: Establishing Your Brand (Your You):</h2>
<p>The first step in finding your voice is really getting to the bottom of your business or service.</p>

	<ul class="with-icons">
<li>What problem is your business or service solving?</li>
<li>Why would someone choose your service over someone else's?</li>
</ul>
<p>Don’t be afraid to get deep in your preliminary planning. Note down what inspired you to start this journey, how your internals operate - everything you can to establish your history. 
</p>
<p>Next up is this chart we like to call your Purpose Chart. It’s a simple way to establish what problem your business is solving, if it’s not immediately obvious. Start with what you do or sell, and from there brainstorm your point(s) of difference, and what your mission is. We’ve used a Tailored Health and Fitness brand for men as an example to get you started.
</p>

<h3>Purpose Chart (Example Only):</h3>
<img src={require('./image-2.png')} alt="Purpose Chart Example" className="align-centre" align="centre" />

<br></br>
<h2>Step 2: Defining Your Audience (Your Who):</h2>
<p>After you’ve worked out your YOU (your purpose, your values and mission), it’s time to work out your WHO. </p>

<ul class="with-icons">
<li>Who are you writing for?</li>
<li>How can you reach them?</li>
</ul>

<p>This step you’ll create an <b>Ideal Customer Profile </b>- an ‘imaginary’ customer that you will have in mind at all points of internal and external communications. Whenever you’re not sure what to write or what message to present, imagine you’re talking directly to this one singular person. Give your person a name, and imagine you are writing to them every time you put pen to paper.</p>
<p>To nail down your WHO, we recommend using a Customer Profile Chart. We’ve created an example using a fresh food delivery service, and named our Ideal Customer 'Jessica'.</p>

<h3>Customer Profile Chart (Example Only):</h3>
<img src={require('./image-3.png')} alt="Customer Profile Chart Example" className="align-centre" align="centre" />

<p>If you already have Google Analytics running, or your Facebook Pixel installed, you have an advantage. These tools give you fantastic insights into who is ALREADY connecting with your brand - their age, gender, interests, location and device used. Use any data you have available to establish the one person you want to be talking to about your brand.</p>


<br></br>
<h2>Step 3: Your Purpose for Communicating (Your WHY):</h2>
<p>Your brand strategy and messaging should all be centred around creating a solution for a problem your Ideal Customer is facing. But an issue many brands face is with inconsistency. They may know their You and their Who, but they don’t know their Why. </p>
<p>When you have a solid purpose for writing, it should come naturally. </p>

<br></br>
<p>There are 5 key voices that you can align your brand with. </p>
<ul class="with-icons">
<li><b>The Scholar</b> - You know absolutely everything there is to know about your industry, and talk in specific jargon and idioms. Eg: scientists, business to business blogs.</li>
<li><b>The Guide</b> - Salesy undertone with a friendly overtone. You want to help people. Eg: DIY pages, home improvement bloggers, realtors.</li>
<li><b>The Friend</b> - Minimal sales tone, mostly a voice that people feel they can rely on or relate to. Eg: counsellors, psychologists.</li>
<li><b>The Authority Figure</b> - More friendly than a Scholar, but still well informed. Able to carry influence and persuasion within your industry. Eg: builders of eco-friendly homes, news pages.</li>
<li><b>The Seller</b> - Every message has an underlying sales pitch, constant sales, everyone can improve and your services are needed to get them there. Eg: web audit services, banks, selected retailers.</li>
</ul>

<p>Use these voices to narrow down who your Ideal Customer is going to resonate the most with, and what your brand’s purpose aligns to the best.</p>


<br></br>
<h2>Step 4: Team Transparency (Your People):</h2>
<p>Establishing a trustworthy, reliable and steady brand relies on making sure everyone has your brand voice in back of mind across all communications. Once you’ve defined your purpose, your Ideal Customer, and your voice, it’s time to explain with your team how they should be communicating across all platforms. 
</p>
<p>Your brand voice should be in your Brand Guidelines, and also in the back of every team member’s mind when writing, filming, talking or presenting. </p>

<br></br>
<h2>Step 5: Start Connecting (Your Audience):</h2>
<p>Consumers in 2020 are craving human connection, a real voice, and a face to the brands they use. Now you’ve established your voice, start creating these connections. If you don’t have social media, get on it! Create conversation with engaging content, creative, honest captions and reply to comments on your posts. If we can pass on any of our knowledge to you for free, it would be to start a conversation with your consumers. </p>
<p>The more consistent you are with your voice, the more trustworthy and authentic you present, and the more people will want your product or services.</p>


							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/EstablishingAVoiceForYourBrand/index.js